import React from "react";
import Button from "../atoms/Button";
import Heading from "../atoms/Heading";
import { useNavigate } from "react-router-dom";
import LOGO from '../../assets/logos/logoRSazul.jpeg';
import FONDO from '../../assets/logos/IMG_0065.JPG';

const HomeTemplate = () => {
	const navigate = useNavigate();

	const handleGo = () => {
		navigate("/login");
	};

	return (
		<div className="relative min-h-screen w-full flex flex-col justify-center items-center text-center overflow-hidden">
			<img
				src={FONDO}
				className="absolute inset-0 w-full h-full object-cover"
				alt="Fondo"
			/>
			<div className="absolute inset-0 bg-rs-azul/80"></div>
			<div className="relative z-10 p-4 flex flex-col items-center space-y-4">
				<img
					src={LOGO}
					className="h-64 aspect-square rounded-full"
					alt="Logo Ramirez Soto"
				/>
				<Heading text="Ramírez Soto Administración" color="white" />
				<div className="flex flex-row space-x-4">
					<Button bgColor="red" text="Iniciar sesión" onClick={handleGo} />
				</div>
			</div>

		</div>
	);
};

export default HomeTemplate;